import { api, authHeader } from "../configs/axiosConfigs";

const baseBySource = (source) =>
  source === "Management"
    ? "/SLN/Management/Invoices"
    : "/SLN/SolarentOperator/Invoices";

const OperatorInvoicesApi = {
  create: async (source, data) => {
    const response = await api.request({
      url: baseBySource(source),
      method: "POST",
      headers: authHeader(),
      data,
    });
    return response.data;
  },

  getById: async (source, invoiceId) => {
    const response = await api.request({
      url: `${baseBySource(source)}/${invoiceId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  sendSms: async (source, invoiceId) => {
    const response = await api.request({
      url: `${baseBySource(source)}/${invoiceId}/SendSms`,
      method: "POST",
      headers: authHeader(),
    });
    return response.data;
  },

  cancel: async (source, invoiceId, reason) => {
    const response = await api.request({
      url: `${baseBySource(source)}/${invoiceId}/Cancel`,
      method: "POST",
      headers: authHeader(),
      data: { reason },
    });
    return response.data;
  },
};

export const INVOICE_CATEGORIES = [
  { value: 1, label: "نیروگاه / پروژه" },
  { value: 2, label: "هزینه خدمات" },
  { value: 3, label: "هزینه بازدید" },
  { value: 4, label: "هزینه نگهداری" },
  { value: 5, label: "هزینه مانیتورینگ" },
  { value: 6, label: "اصلاحیه مالی" },
  { value: 99, label: "سایر موارد" },
];

export default OperatorInvoicesApi;
